// src/utils/version.ts
export const appVersion = __APP_VERSION__
